import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

/**
 * Whether the viewer can override / skip-level change requests for a given
 * entity domain (RSP-1528 §11). The V3 authority is the entity-type Manager
 * companion `${resource}_change_request:update` — NOT the legacy
 * `delete:change_request` permission, which V3 Managers don't hold (that gap
 * hid the override buttons from Managers).
 *
 * tRPC-only: with the `trpc` flag off the panel keeps the legacy
 * `useHasPermissionQuery('delete:change_request')` gate and this hook stays
 * disabled.
 *
 * @param resourceType - the CR parent's ObjectType (entity domain)
 */
export const useCanOverrideChangeRequest = (resourceType?: string | null) => {
  const trpc = useTRPC();
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const { data: canOverride = false, isLoading } = useQuery({
    ...trpc.frontend.changeRequest.canOverride.queryOptions({
      resourceType: resourceType ?? '',
    }),
    enabled: trpcEnabled && !!resourceType,
  });

  return { canOverride, loading: trpcEnabled && !!resourceType && isLoading };
};
